import { MapLike } from '@iotv/iotv-v3-types'

export const aggregateSum = <T extends MapLike<any>>(items: T[], k: string) =>
  items.reduce((acc, curr, i) => (typeof curr[k] === 'number' ? acc + curr[k] : acc), 0)

export const aggregateMean = <T extends MapLike<any>>(items: T[], k: string) => aggregateSum(items, k) / (items.length > 0 ? items.length : 1)
